import { getNftContract, getLotteryContract, getStakeContract } from "../index";
import { STAKE_ADDRESS } from "../constants";
import { assertWalletReady, sendContractMethod, formatTokenAmount } from "./txHelper";
import { getRusdBalance, getLpBalance } from "./tokenService";


export async function fetchStakeContractInfo() {
  const [rusdBalance, lpBalance] = await Promise.all([
    getRusdBalance(STAKE_ADDRESS),
    getLpBalance(STAKE_ADDRESS),
  ]);

  return {
    address: STAKE_ADDRESS,
    rusdBalance: formatTokenAmount(rusdBalance),
    lpBalance: formatTokenAmount(lpBalance),
  };
}

export async function fetchAdminTargets() {
  const stake = getStakeContract();
  const nft = getNftContract();

  const [lotteryAddress, nftOwner] = await Promise.all([
    stake.methods.lotteryAddress().call(),
    nft.methods.owner().call(),
  ]);

  return {
    lottery: {
      label: "抽奖合约",
      address: lotteryAddress,
    },
    admin: {
      label: "管理员自己",
      address: nftOwner,
    },
  };
}

export async function getAdminAuthorityStatus(accountAddress) {
  if (!accountAddress) {
    return {
      isAdmin: false,
      isAuthorized: false,
    };
  }

  const nft = getNftContract();
  const nftOwner = await nft.methods.owner().call();

  const isAdmin = nftOwner?.toLowerCase() === accountAddress.toLowerCase();

  return {
    isAdmin,
    isAuthorized: isAdmin,
  };
}

export async function adminMintCard({ to, cardType, quantity }) {
  console.log({ to, cardType, quantity })
  assertWalletReady();
  const nft = getNftContract();
  const amount = Number(quantity);

  if (!to) {
    throw new Error("请选择抽奖合约地址");
  }
  if (!amount || amount <= 0) {
    throw new Error("请输入有效数量");
  }

  const method = nft.methods.adminMint(to, cardType, amount);
  return sendContractMethod(method);
}
